/** @format */

import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

import DataTable from "./DataTable";
import Typography from "@mui/material/Typography";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import Alert from "@mui/material/Alert";

import Chip from "@mui/material/Chip";
import axios from "axios";

const shipmentColumns = [
  {
    field: "shippingId",
    headerName: "Shipping Id",
    width: 150,
    renderCell: (params) => {
      return (
        <NavLink to={`/shipment/${params.row.id}`}>{params.row.id}</NavLink>
      );
    },
  },
  { field: "blNo", headerName: "SL No", width: 150 },
  { field: "poNumber", headerName: "PO No", width: 150 },
  { field: "qty", headerName: "QTY", width: 150 },
  { field: "invoiceNo", headerName: "Invoice No", width: 150 },
  { field: "invoiceVal", headerName: "Invoice Value", width: 200 },
  {
    field: "status",
    headerName: "Status",
    width: 250,
    renderCell: (params) => {
      switch (params.row.status) {
        case "PENDING_PAYMENT_DET":
          return (
            <Chip
              label="Pending payment details"
              variant="outlined"
              sx={{ width: "180px" }}
              color="warning"
            />
          );

        case "DRAFT":
          return (
            <Chip
              label="Draft"
              variant="outlined"
              sx={{ width: "180px" }}
              color="info"
            />
          );

        case "SUBMITTED":
          return (
            <Chip
              label="Submitted"
              variant="outlined"
              sx={{ width: "180px" }}
              color="success"
            />
          );

        default:
          break;
      }
    },
  },
];

const AllShipments = () => {
  const [shipmentList, setShipmentList] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  async function deleteShipments(listOfShipments) {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/v1/shipment`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
          data: listOfShipments,
        }
      );
      console.log(response.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function getAllShipmentList() {
    setIsFetching(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/shipments?vendorId=""`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(response);
      const formattedShipmentList = response.data.list.map((shipment) => {
        return {
          id: shipment.shippingId,
          blNo: shipment.blNo,
          invoiceNo: shipment.invoiceNo,
          invoiceVal: shipment.invoiceVal,
          poNumber: shipment.poNumber,
          qty: shipment.qty,
          shippingId: shipment.shippingId,
          status: shipment.status,
        };
      });
      setShipmentList(formattedShipmentList);
    } catch (err) {
      console.log(err);
    }
    setIsFetching(false);
  }
  useEffect(() => {
    getAllShipmentList();
  }, []);

  return (
    <>
      {isFetching ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <>
          <Alert
            severity="success"
            color="success"
            sx={{ my: 2 }}
            iconMapping={{
              success: <FormatListBulletedIcon fontSize="inherit" />,
            }}>
            <Typography component="h1" variant="h6">
              List of all Shipment & Payment Details
            </Typography>
          </Alert>
          <DataTable
            rows={shipmentList}
            columns={shipmentColumns}
            updateList={setShipmentList}
            deleteList={deleteShipments}
          />
        </>
      )}
    </>
  );
};

export default AllShipments;
